import { AutoComplete, Avatar, Badge, Button, Col, Collapse, Dropdown, Form, Image, Input, Menu, Modal, Popconfirm, Popover, Row, Spin, Steps, message, notification } from "antd";
import * as AUTH_SERVICES from "api/services/auth/auth.services";
import * as USER_SERVICES from "api/services/chat/user-chat/user.services";
import { FC, Fragment, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  closePorteFeuilleDrawer__,
  closeProfileDrawer,
  logout,
  openProfileDrawer,
} from "store/auth/authSlice";
import {
  closePaiementDrawer,
  openChatDrawerStudent,
  openPaiementDrawer,
} from "store/chat/mainSlice";

import * as appRoutes from "config/routes.config";
import { useTranslation } from "react-i18next";
import { Link, NavLink, useNavigate } from "react-router-dom";

//!COMPONENTS
import Container from "components/container";

//!IMAGES
import { DownOutlined } from '@ant-design/icons';
import call from "assets/images/app/header/call.svg";
import logo from "assets/images/app/header/logo.svg";
import TeacherIcon from "assets/images/teacher/teacher.svg";
/* import ActivitiesIcon from "./assets/images/ads.svg"; */

//TEACHER

/* import MesClasses from "./assets/images/classes.svg"; */
import starCoins from "assets/images/app/coins.svg";
import score from "assets/images/app/score.svg";
import ArrowDown from "../../assets/images/app/arrow_bottom_down.svg";
import ArrowUp from "../../assets/images/app/arrow_top_up.svg";
import AvatarIcon from "../../assets/images/app/avatar_icon.svg";
import dollarCoins from "../../assets/images/app/dollar-coins.png";
import Calendar from "../../assets/images/app/header/calendar.svg";
import LogoutIcon from "../../assets/images/app/logout_icon.svg";
import Msg from "../../assets/images/app/messagerie.svg";
import MenuIcon from "../../assets/images/app/new_menu.svg";
import schoolPic from "../../assets/images/app/school.svg";
import Classe from "../../assets/images/icons/teacher_classes.svg";
import Content from "./assets/images/content.svg";
import Prof from "./assets/images/prof.svg";

//!STYLES
import MenuModal from "screens/teacher/components/menu";
import st from "../userNavBar/style.module.css";
import s from "./assets/headers.module.css";
import style from "./assets/user.header.module.css";

//!REDUX
import { findLevelsById } from "api/services/levels/levels.services";
import { FLAGS, StatusCode, UserRoles } from "common/enums";
import AppButton from "components/libs/button";
import NotificationStudent from "components/notifications/student";
import RankingDrawer from "components/rankingDrawer";
import UserNavBar from "components/userNavBar";
import { setIsNewData } from "store/app/appSlice";
import { setChatReceiverId, toggleAppChat } from "store/AppChat/appChat";
import { clearRoom } from "store/chat/roomSlice";
import { clearRooms } from "store/chat/roomsSlice";
import { useFindRoomMutation } from "store/services/chat";
import {
  useGetNotifByUserQuery,
  useViewNotifByUserMutation,
} from "store/services/teacher/notification.services";
import * as BOOKING_SERVICES from "../../api/services/studentReservation/studentReservation.services";
import NavUser from "./NavUser";

const { Step } = Steps;
const { Option } = AutoComplete;
const { Panel } = Collapse;

const UserStudent: FC = () => {
  //!HOOKS
  const { isLoggedIn } = useSelector((state) => state.auth);
  const { isFullscreen } = useSelector((state) => state.app);

  //!RETURN
  return (
    <div>
      {isLoggedIn && !isFullscreen && <WhenConnected />}
      {!isLoggedIn && <WhenNotConnected />}
    </div>
  );
};

const WhenConnected: FC = () => {

  const STUDENT = [
    {
      id: 0,
      name: "Mes classes",
      icon: Classe,
      link: appRoutes.STUDENT_MY_CLASS,
      iconSize: 25,
    },
    {
      id: 3,
      name: "Je m'entraine",
      icon: Content,
      iconSize: 30,
      link: appRoutes.STUDENT_MY_CONTENT,
    },
    {
      id: 4,
      name: "Trouver un prof",
      icon: Prof,
      link: appRoutes.STUDENT_SEARCH_BEST_TEACHER,
      iconSize: 30,
    },
    {
      id: 1,
      name: "Mon calendrier",
      icon: Calendar,
      iconSize: 35,
      link: appRoutes.STUDENT_CALENDAR,
    },
  ];

  //!HOOKS
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.auth);
  const { currentChat } = useSelector((state) => state.appChat);
  const { isNewData } = useSelector((state) => state.app);
  const [formInfos] = Form.useForm();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1151);
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1151);
  };
  window.addEventListener('resize', handleResize);

  const [type, setType] = useState<string>("");

  const [rakingDrawerVisible, setRakingDrawerVisible] = useState(false);
  const showRakingDrawer = (rankType: string) => {
    setType(rankType);
  };

  const onCloseRankingDrawer = () => {
    setType("");
  };

  useEffect(() => {
    if (type !== "") {
      setRakingDrawerVisible(true);
    }
    else {
      setRakingDrawerVisible(false);
    }
  }, [type, rakingDrawerVisible]);

  const {
    data: dataNotif,
    refetch,
    isLoading,
  } = useGetNotifByUserQuery(user._id);

  const [
    viewNotifByUser,
    { data: viewData, isLoading: isLoadingView, isSuccess: isSuccessView },
  ] = useViewNotifByUserMutation();

  //!STATE
  const [visible, setVisible] = useState(false);

  const openMessagerieDrawer = () => {
    dispatch(openChatDrawerStudent());
    dispatch(closeProfileDrawer());
    dispatch(closePorteFeuilleDrawer__());
    dispatch(closePaiementDrawer());
    setVisible(false);
  };
  const openPaiementStudentDrawer = () => {
    dispatch(openPaiementDrawer());
  };
  //!FUNCTIONS

  const openDrawer = () => {
    dispatch(openProfileDrawer());
    setSeeProfile(false);
  };

  let filterNotifForMsg =
    dataNotif?.data?.filter(
      (data: any) => data?.type === "messagerie" && data?.seen === false
    ) || [];

  const handleViewAllMessage = (arr: any[]) => {
    arr.map((msg: any) => {
      return viewNotifByUser(msg?._id);
    });
  };

  const [findRoom, { isSuccess }] = useFindRoomMutation();

  const handleDisplaySponsorMSG = () => {
    const finalData = {
      actor1: user?._id,
      actor2: user?.accountManaged,
      flag: FLAGS.SINGLE_FLAG,
      type: "",
      instaprof: "",
    };
    findRoom(finalData);
    dispatch(toggleAppChat(true));
    dispatch(setChatReceiverId(user?.accountManaged));
  };

  const { socket } = useSelector((state) => state.appChat);
  const [visibleDemandModal, setVisibleDemandModal] = useState(false);
  const [visibleDissociationModal, setVisibleDissociationModal] = useState(false);
  const [isMessageLoading, setMessageLoading] = useState<boolean>(false);

  const [visibleOptions, setVisibleOptions] = useState(false);
  const [seeProfile, setSeeProfile] = useState(false);
  const [wantDisconnect, setWantDisconnect] = useState(false);
  const popoverReportRef = useRef<HTMLDivElement>(null);
  const [userLevel, setUserLevel] = useState<any>();

  const [users, setUsers] = useState([]);
  const [bookingCount, setBookingCount] = useState<number>(0);

  const OnSelectUser = useCallback(async (userNameOrEmail: string) => {
    if (userNameOrEmail.length >= 3) {
      const roles = [UserRoles.TEACHER];

      try {
        const response = await USER_SERVICES.findOne(userNameOrEmail, roles);
        if (response?.status === "OK") {
          setUsers(response?.data);
        } else {
          if (userNameOrEmail.length >= 10) {
            message.warning(response?.message);
          }
        }
      } catch (error) {
        if (userNameOrEmail.length >= 6) {
          notification["info"]({
            message: "Information",
            description: "Utilisateur non trouvé : )",
            style: {
              width: 300,
            },
          });
        }
      }
    }
  }, []);

  const showDemandModal = () => {
    setVisibleDemandModal(true);
  };

  const handleCancel = () => {
    setVisibleDemandModal(false);
  };

  const showDissociationModal = () => {
    setVisibleDissociationModal(true);
  };

  const handleCancelDissociation = () => {
    setVisibleDissociationModal(false);
  };

  const [demandTeacherId, setDemandTeacherId] = useState<string>('');

  const dropdownMenu = (
    <Menu>
      <Menu.Item key="message" onClick={handleDisplaySponsorMSG}>Envoyer un message</Menu.Item>
      <Menu.Item key="budget" onClick={showDemandModal}>Demander un budget</Menu.Item>
      <Menu.Item key="params" onClick={showDissociationModal}>Paramètres avancés</Menu.Item>
    </Menu>
  );

  const sendDemand = async (values: any) => {
    setMessageLoading(true);
    try {
      const response = await AUTH_SERVICES.sendBudgetDemand(user?.accountManaged, demandTeacherId, user?._id, values.montant, values?.message);
      if (response?.statusCode === StatusCode.CREATED) {
        message.success({
          content: "Demande envoyée ",
        });
        setMessageLoading(false);
        setVisibleDemandModal(false);
      }
      else {
        message.warning({
          content: "Ooops, Une erreur est survenue",
        });
        setMessageLoading(false);
      }
    } catch (error: any) {
      let content = "";
      for (
        let index = 0;
        index < error?.response?.data?.message?.length;
        index++
      ) {
        content = error?.response?.data?.message[index] + ", " + content;
      }
      message.error({
        content: content,
      });
    }
  }

  const getBookingData = async () => {
    try {
      const response = await BOOKING_SERVICES.getBookingData(user?._id);
      if (response?.statusCode === StatusCode.OK) {
        if (response?.data) {
          setBookingCount(response?.data?.length);
        }
        else {
          setBookingCount(0);
        }
      }
    } catch (error: any) {
      console.error("Error fetching booking data:", error);
    } finally {
      dispatch(setIsNewData(false));
    }
  };

  const dissociateAccount = async () => {
    setMessageLoading(true);
    try {
      const response = await AUTH_SERVICES.dissociateAccount(user?._id);
      if (response?.statusCode === StatusCode.CREATED) {
        message.success({
          content: "Compte deconnecté ",
        });
        setMessageLoading(false);
        setVisibleDissociationModal(false);
        setTimeout(() => {
          window.location.reload();
        }, 2000);
      }
      else {
        message.warning({
          content: "Ooops, Une erreur est survenue",
        });
        setMessageLoading(false);
      }
    } catch (error: any) {
      let content = "";
      for (
        let index = 0;
        index < error?.response?.data?.message?.length;
        index++
      ) {
        content = error?.response?.data?.message[index] + ", " + content;
      }
      message.error({
        content: content,
      });
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    setTimeout(() => {
      if (popoverReportRef.current && !popoverReportRef.current.contains(event.target as Node)) {
        if (seeProfile || wantDisconnect) {
          console.log("Action selected!");
        } else {
          setVisibleOptions(false);
        }
      }
    }, 200);
  };

  const getLevelById = useCallback(
    async (idLevel: any) => {
      try {
        if (idLevel) {
          const response = await findLevelsById(idLevel);
          if (response.statusCode === StatusCode.OK) {
            setUserLevel(response?.data['title']);
          }
        }
      } catch (error) { }
    },
    [userLevel]
  );

  const clearCookies = () => {
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/");
    });
  };

  const disconnect = async () => {
    setWantDisconnect(false);
    await socket.emit("unsubscribe", user?._id);
    socket?.disconnect();
    dispatch(clearRoom());
    dispatch(clearRooms());
    dispatch(logout());
    clearCookies();
    localStorage.removeItem("couponCode");
    localStorage.clear();
    sessionStorage.clear();
  };

  const content = (
    <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
      <div style={{ fontSize: isMobile ? "0.8em" : "13px", cursor: "pointer", display: "flex", flexDirection: "column" }}>
        <span style={{ color: "#80b1b2" }}>{user?.lastname}</span>
        <span style={{ color: "#707070" }}>{userLevel}</span>
      </div>
      <div style={{ height: "1px", width: "90%", margin: "0px auto", background: "#BFBCBC", marginTop: "5px", marginBottom: "5px" }}></div>
      <div onClick={() => { setSeeProfile(true); openDrawer() }} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#464c4c", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#e5f5f5", alignItems: "center", justifyContent: "center", width: "100%", height: "30px", paddingLeft: "5px", paddingRight: "5px" }}>
        <img src={user?.profil || AvatarIcon} height={15} style={{ marginRight: "5px" }}></img>
        Mon profil
      </div>
      <Popconfirm
        placement="left"
        title={"Tu confirmes la déconnexion ?"}
        onConfirm={disconnect}
        onCancel={() => setWantDisconnect(false)}
        okText="Oui"
        cancelText="Non"
      >
        <Button onClick={() => setWantDisconnect(true)} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#f67675", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#ffeae5", alignItems: "center", justifyContent: "center", width: "100%", height: "30px", marginTop: "5px", paddingLeft: "5px", paddingRight: "5px" }}>
          <img src={LogoutIcon} height={15} style={{ marginRight: "5px" }}></img>
          Se déconnecter
        </Button>
      </Popconfirm>
    </div>
  );

  const contentMobile = (
    <div onClick={(e) => e.stopPropagation()} style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start", width: "100%" }}>
      <div style={{ display: "flex", flexDirection: "row", width: "100%", gap: "2.5px", alignItems: "center", justifyContent: "center" }}>
        <div className={st.infoBoxSolde}>
          <div className={st.infoColumn} onClick={() => openPaiementStudentDrawer()}>
            <div className={st.left}><img src={dollarCoins} height={isMobile ? 10 : 15} className={st.leftText}></img> Solde</div>
            <div className={st.right}>{user?.coins}<span className={st.coinsInfo}>EUR</span></div>
          </div>
        </div>
        {user?.rankEtab !== undefined && user?.etablissement !== "Autre établissement" && <div className={st.infoBoxHoverSchool}>
          <div className={st.infoColumn} onClick={() => showRakingDrawer("school")}>
            <div className={st.left}><img src={schoolPic} height={isMobile ? 10 : 15} className={st.leftText}></img> Rank</div>
            <div className={st.right}>{user?.rankEtab}<span className={st.classementInfo}>{user?.rankEtab === 1 ? "er" : "e"}</span></div>
          </div>
        </div>}
        {user?.rankNational !== undefined && <div className={st.infoBoxHoverNat}>
          <div className={st.infoColumn} onClick={() => showRakingDrawer("national")}>
            <div className={st.left}><img src={schoolPic} height={isMobile ? 10 : 15} className={st.leftText}></img> Pays</div>
            <div className={st.right}>{user?.rankNational}<span className={st.classementInfo}>{user?.rankNational === 1 ? "er" : "e"}</span></div>
          </div>
        </div>}
        <div className={st.userNavInfoBox}>
          <div className={st.userNavBox}>
            <div className={st.infoBox}>
              <div className={st.info}>
                <div className={st.left}><img src={starCoins} height={isMobile ? 10 : 15} className={st.leftText}></img> Coins</div>
                <div className={st.right}>{user?.points}<span className={st.coinsInfo}>CNS</span></div>
              </div>
            </div>
            <div className={st.infoBox}>
              <div className={st.info}>
                <div className={st.left}><img src={score} height={isMobile ? 10 : 15} className={st.leftText}></img> Score</div>
                <div className={st.right}>{user?.score}<span className={st.coinsInfo}>PTS</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ height: "1px", width: "90%", margin: "0px auto", background: "#BFBCBC", marginTop: "5px", marginBottom: "5px" }}></div>
      <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", textAlign: "center", width: "100%" }}>
        <div style={{ fontSize: isMobile ? "0.8em" : "13px", cursor: "pointer", display: "flex", flexDirection: "column" }}>
          <span style={{ color: "#80b1b2", textTransform: "capitalize" }}>{user?.lastname}</span>
          <span style={{ color: "#707070" }}>{userLevel}</span>
        </div>

        <div onClick={() => { setSeeProfile(true); openDrawer() }} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#464c4c", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#e5f5f5", alignItems: "center", justifyContent: "center", height: "30px", paddingLeft: "5px", paddingRight: "5px" }}>
          <img src={user?.profil || AvatarIcon} height={12} style={{ marginRight: "5px" }}></img>
          Mon profil
        </div>

        <Popconfirm
          placement="left"
          title={"Tu confirmes la déconnexion ?"}
          onConfirm={disconnect}
          onCancel={() => setWantDisconnect(false)}
          okText="Oui"
          cancelText="Non"
        >
          <Button onClick={() => setWantDisconnect(true)} style={{ fontSize: isMobile ? "0.8em" : "12px", color: "#f67675", cursor: "pointer", display: "flex", flexDirection: "row", borderRadius: "5px", background: "#ffeae5", alignItems: "center", justifyContent: "center", height: "30px", paddingLeft: "5px", paddingRight: "5px" }}>
            <img src={LogoutIcon} height={15} style={{ marginRight: "5px" }}></img>
            Se déconnecter
          </Button>
        </Popconfirm>
      </div>
    </div>
  );

  useEffect(() => {
    if (user) {
      getBookingData();
    }
  }, [user]);

  useEffect(() => {
    if (isNewData) {
      getBookingData();
    }
  }, [isNewData]);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [seeProfile, wantDisconnect]);

  useEffect(() => {
    getLevelById(user?.levelId);
  }, [user]);

  //!RETURN
  return (
    <Fragment>
      <header className={style.header}>
        {user?.organisationName && user?.accountManaged && <div className={style.topBarStudent}>
          <div>Compte géré par : <span className={style.parentOrganismeName}>{user?.organisationName}</span></div>
          <div style={{ marginLeft: isMobile ? "0px" : "20px", marginRight: isMobile ? "0px" : "20px" }}>
            <Dropdown overlay={dropdownMenu} placement="bottomLeft">
              <Button className={style.menuButton}>
                Menu <DownOutlined />
              </Button>
            </Dropdown>
          </div>
        </div>}
        <Container>
          <div className={style.menu}>
            <Link to={"/"}>
              <div className={style.logoContainer}>
                <img src={logo} height={50} alt="logo" ></img>
              </div>
            </Link>

            {/* Mobile */}
            {isMobile && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", width: "auto", gap: "5px" }}>
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "50px", width: "75px" }}>
                <Avatar
                  style={{ backgroundColor: "#FFF", border: "1px solid #80b1b2", marginRight: "5px" }}
                  size={35}
                  src={
                    <Image
                      fallback={`http://gravatar.com/avatar${user?.uid}?d=identicon`}
                      preview={false}
                      src={
                        !!user?.profile
                          ? user?.profile
                          : `https://gravatar.com/avatar/${user?._id}?d=identicon`
                      }
                    />
                  }
                >
                  {""}
                </Avatar>
                <Popover
                  visible={visibleOptions}
                  placement="bottom"
                  content={contentMobile}
                  trigger="click"
                  overlayStyle={{ left: 0, right: 0 }}
                  style={{ left: 0, right: 0 }}
                  overlayInnerStyle={{ left: 0, right: 0 }}
                  overlayClassName="student-popover"
                >
                  <div ref={popoverReportRef} className={s.optionButton} onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); }}><img src={visibleOptions ? ArrowUp : ArrowDown} height={17}></img></div>
                </Popover>
              </div>

              <div className={style.notifIcon}>
                <NotificationStudent
                  dataNotif={dataNotif}
                  refetch={refetch}
                  viewNotifByUser={viewNotifByUser}
                  isLoading={isLoading}
                />
              </div>
            </div>}

            {/* desktop-menu */}
            {!isMobile && <nav className={style.nav__bar}>
              <ul className={style.nav__item}>
                {STUDENT.map((item) => (
                  <li className={style.__isMobile}>
                    <ul>
                      <li className={style.navbarItemBox}>
                        <Link to={item?.link}>
                          {item.id === 1 && bookingCount > 0 && <li style={{ height: 20, width: 20, background: "red", color: "white", borderRadius: "50%", textAlign: "center", position: "relative", top: "10px", right: "-30px", zIndex: "77", display: "flex", alignItems: "center", justifyContent: "center" }}>{bookingCount}</li>}
                          <img
                            src={item.icon}
                            height={item.iconSize}
                            style={{ position: "relative", top: item.id === 1 && bookingCount > 0 ? "-10px" : "0px" }}
                          />
                        </Link>
                      </li>
                      <li>
                        {" "}
                        <NavLink
                          to={item.link}
                          className={({ isActive }) =>
                            isActive ? "activeLink" : ""
                          }
                        >
                          {item.name}
                        </NavLink>
                      </li>
                    </ul>
                  </li>
                ))}

                <li className={style.newNavBar}>
                  <UserNavBar />
                </li>

                <li>
                  <Badge size="small" count={filterNotifForMsg?.length} offset={[-5, 5]}>
                    <div
                      onClick={() => {
                        dispatch(toggleAppChat(true));
                        handleViewAllMessage(filterNotifForMsg);
                      }}
                      className={style.menuBoxMessage}
                    >
                      <div className={style.menuItemBox}>
                        <Image preview={false} src={Msg} width={25} />
                      </div>
                      <span className={style.menuTitle}>Messages</span>
                    </div>
                  </Badge>
                </li>

                <li>
                  <NotificationStudent
                    dataNotif={dataNotif}
                    refetch={refetch}
                    viewNotifByUser={viewNotifByUser}
                    isLoading={isLoading}
                  />
                </li>

                <li className={style.menuBox} onClick={() => setVisible(true)} style={{ marginLeft: "0px" }}>
                  <div className={style.menuItemBox}><Image preview={false} src={MenuIcon} width={25} /></div>
                  <span className={style.studentMenuTitle}>Menu</span>
                </li>
              </ul>
            </nav>}

            {!isMobile && <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", height: "50px", width: "75px" }}>
              <Avatar
                style={{ backgroundColor: "#FFF", border: "1px solid #80b1b2", marginRight: "5px" }}
                size={35}
                src={
                  <Image
                    fallback={`http://gravatar.com/avatar${user?.uid}?d=identicon`}
                    preview={false}
                    src={
                      !!user?.profile
                        ? user?.profile
                        : `https://gravatar.com/avatar/${user?._id}?d=identicon`
                    }
                  />
                }
              >
                {""}
              </Avatar>
              <Popover
                visible={visibleOptions}
                placement="bottom"
                content={content}
                trigger="click"
                style={{ height: "70px !important", width: "350px !important", borderRadius: "8px", boxShadow: "4px 8px 16px #8B8B8B38", border: "0.5px solid #BFBCBC" }}
                className={s.customPopover}
                overlayClassName={s.customPopover}
              >
                <div ref={popoverReportRef} className={s.optionButton} onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); }}><img src={visibleOptions ? ArrowUp : ArrowDown} height={17}></img></div>
              </Popover>
            </div>}
          </div>
        </Container>
      </header>

      <RankingDrawer visible={rakingDrawerVisible} onClose={onCloseRankingDrawer} user={user} type={type} />

      <MenuModal
        visible={visible}
        setVisible={setVisible}
        openDrawer={openDrawer}
        openMessagerieDrawerStudent={openMessagerieDrawer}
        openPaiementDrawer={openPaiementStudentDrawer}
      />

      {
        !currentChat && (
          <NavUser
            openMessagerieDrawer={openMessagerieDrawer}
            visible={visible}
            setVisible={setVisible}
          />
        )
      }

      <Modal
        title={<div style={{ fontFamily: "CartoonFont", fontSize: "1.8em", display: "flex", alignItems: "center", justifyContent: "center" }}>Demander un budget</div>}
        visible={visibleDemandModal}
        onCancel={handleCancel}
        footer={null}
        closable={true}
      >
        <p style={{ fontFamily: "CartoonFont", fontSize: "1.8em" }}>Tu peux demander à ton tuteur de recharger ton compte</p>
        <Form
          validateTrigger={["onFinish"]}
          name="registerParent"
          autoComplete="off"
          form={formInfos}
          onFinish={sendDemand}
        >
          <div style={{ border: "1px solid #C0C0C0", borderRadius: "8px", paddingTop: "5px", paddingBottom: "5px", marginBottom: "20px", }}>
            <AutoComplete
              bordered={false}
              style={{ width: "100%" }}
              onChange={OnSelectUser}
              placeholder="Rechercher par Nom ou Email"
            >
              {users.map((user: any, i: number) => (
                <Option key={i} value={user?.firstname}>
                  <div
                    onClick={async () => {
                      setDemandTeacherId(user?._id);
                    }}
                  >
                    <Row justify="space-between">
                      <Col>
                        <span style={{ textTransform: "capitalize" }}>
                          {" "}
                          {`${user?.pseudo || ""} ( ${user?.lastname || ""} ${user?.firstname || ""
                            } )`}
                        </span>
                      </Col>
                      <Col>
                        <Avatar src={user?.profile || TeacherIcon} />
                      </Col>
                    </Row>
                  </div>
                </Option>
              ))}
            </AutoComplete>
          </div>

          <Form.Item
            name="montant"
            rules={[{ required: true }]}
            style={{ marginBottom: "20px" }}
          >
            <Input
              type="number"
              className={s.field}
              placeholder={"Budget à recharger €"}
              maxLength={30}
            />
          </Form.Item>

          <Form.Item
            name="message"
            rules={[{ required: true }]}
            style={{ marginBottom: "20px" }}
          >
            <Input.TextArea
              className={s.field}
              placeholder={"Ajouter un message ( optionnel )"}
              maxLength={255}
              rows={3}
            />
          </Form.Item>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
            <Form.Item>
              <AppButton loading={isMessageLoading} htmlTypeSubmit={true}>Envoyer ma demande</AppButton>
            </Form.Item>
          </div>
        </Form>
      </Modal>

      <Modal
        title={<div style={{ fontFamily: "CartoonFont", fontSize: "1.8em", display: "flex", alignItems: "center", justifyContent: "center" }}>Paramètres avancés</div>}
        visible={visibleDissociationModal}
        onCancel={handleCancelDissociation}
        footer={null}
        closable={true}
        destroyOnClose={true}
      >
        <Collapse
          accordion
          expandIconPosition="end"
          className="custom-collapse"
        >
          <Panel header="Quitter l'organisme" key="1">
            <p style={{ fontSize: "1em" }}>En passant à un compte normal, tu pourras gérer ton profil en toute autonomie.<br />Ton administrateur ne pourra plus accéder à ton tableau de bord, ni recharger ton compte. Tu auras le contrôle total de ton expérience sur la plateforme !</p>
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
              {!isMessageLoading && <Button style={{ borderRadius: "8px", color: "white", backgroundColor: "green", marginRight: "20px", height: "50px" }} onClick={handleCancelDissociation}>Annuler</Button>}
              {!isMessageLoading && <Button style={{ borderRadius: "8px", color: "white", backgroundColor: "red", height: "50px" }} onClick={() => dissociateAccount()}>Confirmer l'opération</Button>}
              <Spin spinning={isMessageLoading} size="large" />
            </div>
          </Panel>
          {/* <Panel header="Section 2" key="2">
            <p>Content for Section 2</p>
          </Panel> */}
          {/* <Panel header="Section 3" key="3">
            <p>Content for Section 3</p>
          </Panel> */}
        </Collapse>
        {/* <p style={{ fontSize: "1.2em" }}>En passant à un compte normal, vous pourrez gérer votre profil en toute autonomie.<br />Votre administrateur ne pourra plus accéder à votre tableau de bord, ni recharger votre compte. Vous aurez le contrôle total de votre expérience sur la plateforme!</p>
        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
          {!isMessageLoading && <Button style={{ borderRadius: "8px", color: "white", backgroundColor: "green", marginRight: "20px", height: "50px" }} onClick={handleCancelDissociation}>Annuler</Button>}
          {!isMessageLoading && <Button style={{ borderRadius: "8px", color: "white", backgroundColor: "red", height: "50px" }} onClick={() => dissociateAccount()}>Confirmer l'opération</Button>}
          <Spin spinning={isMessageLoading} size="large" />
        </div> */}
      </Modal>

    </Fragment >
  );
};

const WhenNotConnected: FC = () => {
  //!HOOKS
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <header className={s.app__header}>
      <Container>
        <div className={s.nav}>
          <div className={s.logo}>
            <Link to="/">
              <img src={logo} height={50} alt="logo" ></img>
            </Link>
          </div>

          <ul className={s.nav__links}>
            <li className={s.nav__item}>
              <a href="tel:00212522334455">
                <Image preview={false} width={20} src={call} alt="logo" />
                05 22 33 44 55
              </a>
            </li>
            <li className={s.nav__item}>
              <a href="">contact</a>
            </li>
            <li className={s.nav__item}>
              <Link to={appRoutes.LOGINS}> Se connecter</Link>
            </li>
          </ul>
        </div>
      </Container>
    </header>
    // <Space align="center">
    //     <Button onClick={() => navigate(appRoutes.LOGIN)}>{t('auth.login.loginTitle')}</Button>
    //     <Button onClick={() => navigate(appRoutes.REGISTER)}>{t('auth.register.registerTitle')}</Button>
    // </Space>
  );
};

export default UserStudent;
